import React from "react";
import { useParams } from "react-router-dom";
import {
    INGREDIENTS_EXPLANATIONS,
    notableEffects,
    FLAG_ICONS_COLORS,
    INGREDIENT_FLAG_TRANSLATIONS,
    HAIR_FUNCTION_TRANSLATIONS,
    hairScalpLabels,
} from "../constants";
import "./IngredientDetailPage.css";

const IngredientDetailPage = () => {
    const { ingredient } = useParams();
    const details = INGREDIENTS_EXPLANATIONS[ingredient] || {};

    const getScoreColor = (score) => {
        if (score === 1) return "#4CAF50";
        if (score === 2 || score === 3) return "#FF9800";
        if (score >= 4) return "#F44336";
        return "#9E9E9E";
    };

    const renderFlags = () =>
        details.flags?.map((flag) => {
            const flagInfo = FLAG_ICONS_COLORS[flag] || FLAG_ICONS_COLORS[`${flag}_free`] || {};
            const translatedLabel = INGREDIENT_FLAG_TRANSLATIONS[flag] || flag;

            return (
                <div key={flag} className="idp-flag-item">
                    <span className="idp-flag-icon">{flagInfo.icon || "❓"}</span>
                    <span className="idp-flag-label">{translatedLabel}</span>
                </div>
            );
        });

    const renderCosmeticEffects = () =>
        details.cosmetic_functions?.map((effect) => {
            const effectData = notableEffects.find((e) => e.key === effect);
            return (
                <div key={effect} className="idp-effect-item">
                    <span className="idp-effect-icon">{effectData?.icon || "❓"}</span>
                    <span>{effectData?.label || effect}</span>
                </div>
            );
        });

    const renderFunctions = () =>
        details.functions?.map((func) => {
            const functionData = HAIR_FUNCTION_TRANSLATIONS[func];
            return (
                <div key={func} className="idp-function-item">
                    <span>{functionData?.label || func}</span>
                </div>
            );
        });

    const renderSpecialSituations = () =>
        details.special_situations?.map((situation) => (
            <span
                key={situation}
                className={`idp-special-situation ${situation === "bad_for_pregnants" ? "idp-bad" : "idp-good"
                    }`}
            >
                {situation === "bad_for_pregnants" && "Hamileler için uygun değildir."}
                {situation === "good_for_babies" && "Bebekler için uygundur."}
            </span>
        ));

    const renderHairAndScalp = (type, items) => {
        const labels = hairScalpLabels[type] || {};

        return items
            ?.map((item) => labels[item] || item)
            .join(", ") || "Bilinmiyor";
    };

    return (
        <div className="idp-page">
            <header className="idp-header" style={{ backgroundColor: getScoreColor(details.score) }}>
                <div className="idp-header-content">
                    <h2>{ingredient} {details.localized_name && `(${details.localized_name})`}</h2> 
                    <p>{details.description}</p>
                </div>
            </header>

            <section className="idp-score-section">
                <div className="idp-score-card">
                    <div className="idp-score-badge" style={{ backgroundColor: getScoreColor(details.EWG) }}>
                        {details.EWG || "?"}
                    </div>
                    <div className="idp-score-text">
                        <strong>EWG Skoru</strong>
                        <small>EWG Skoru, içerik güvenliğini derecelendirir. 1 en güvenli, 10 en tehlikelidir.</small>
                    </div>
                </div>
                <div className="idp-score-card">
                    <div className="idp-score-badge idp-cir-badge">
                        {details.CIR || "?"}
                    </div>
                    <div className="idp-score-text">
                        <strong>CIR Değerlendirmesi</strong>
                        <small>CIR, bilimsel incelemelerle içerik güvenliğini değerlendirir.</small>
                    </div>
                </div>
            </section>

            <section>
                <h2 className="idp-section-header">Kozmetik Etkiler</h2>
                <div className="idp-effects-grid">
                    {details.cosmetic_functions?.length
                        ? renderCosmeticEffects()
                        : <p>Kozmetik Etkiler bulunamadı.</p>}
                </div>
            </section>

            <section>
                <h2 className="idp-section-header">İçerik Fonksiyonları</h2>
                <div className="idp-functions-grid">
                    {details.functions?.length
                        ? renderFunctions()
                        : <p>İçerik Fonksiyonları bulunamadı.</p>}
                </div>
            </section>

            <section>
                <h2 className="idp-section-header">İçerik Durumu</h2>
                <div className="idp-flags-grid">
                    {details.flags?.length
                        ? renderFlags()
                        : <p>İçerik Durumu bulunamadı.</p>}
                </div>
            </section>

            <section>
                <h2 className="idp-section-header">Saç ve Deri Uyumluluğu</h2>
                <div className="idp-hair-scalp">
                    {details.hair_type?.length || details.scalp_type?.length ? (
                        <>
                            <p>
                                <strong>Saç Tipi:</strong> {renderHairAndScalp("hair_type", details.hair_type)}
                            </p>
                            <p>
                                <strong>Deri Tipi:</strong> {renderHairAndScalp("scalp_type", details.scalp_type)}
                            </p>
                        </>
                    ) : (
                        <p>Saç ve Deri Uyumluluğu bilgisi bulunamadı.</p>
                    )}
                </div>
            </section>

            <section>
                <h2 className="idp-section-header">Özel Durumlar</h2>
                <div className="idp-special-situations">
                    {details.special_situations?.length
                        ? renderSpecialSituations()
                        : <p>Özel Durumlar bilgisi bulunamadı.</p>}
                </div>
            </section>
        </div>
    );
};

export default IngredientDetailPage;
